import Accordion from '@/common/components/Accordion';
import { CompanyData } from '@/features/companies/types/companies.type';
import { UpdateTefInputModeModal } from '@/features/privateCompanies/pages/Update/components/UpdateTefInputModeModal';
import { SquareCheckIcon } from 'lucide-react';

const TefInputModeSection = ({ company }: { company?: CompanyData }) => {
  return (
    <Accordion
      defaultOpen
      head={(
        <div className="flex items-center gap-x-3">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateTefInputModeModal company={company} />
          </div>

          <p className='text-xl'>
            TEFs
          </p>
        </div>
      )}
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={(
        <div className='flex flex-col gap-4'>
          <div className='flex items-center gap-2'>
            <p>
              Métodos de entradas permitidos:
            </p>

            {Number(company?.client_company_tef_input_modes?.length) > 0 ? company?.client_company_tef_input_modes?.map((tefInputMode, i) => (
              <div key={`capture_method_${i}`} className='flex items-center gap-1 text-white-400'>
                <SquareCheckIcon strokeWidth={1.5} />

                <p>
                  {tefInputMode.tef_input_mode.display_name}
                </p>
              </div>
            )) : (
                <p className='italic font-light'>
                  Todos
                </p>
              )}
          </div>
        </div>
      )}
    />
  )
}

export default TefInputModeSection;
